<template>
  <div>
    <v-card class="pa-3">
      <div class="text-xs-right">
        <v-btn flat icon color="primary" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div v-if="selectedCustomer" class="py-2">
        <v-layout wrap>
          <v-flex xs6>
            <div style="display: flex; align-items: center">
              <div class="px-4">
                <v-avatar size="72">
                  <v-img
                    :lazy-src="selectedCustomer && selectedCustomer.profile_pic"
                    :src="
                      selectedCustomer && selectedCustomer.profile_pic
                        ? selectedCustomer.profile_pic
                        : '/static/img/assets/livechat/profile.png'
                    "
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <template #placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </v-avatar>
              </div>
              <div>
                <div class="font-weight-bold">Name :</div>
                <div>{{ selectedCustomer.line_name }}</div>
              </div>
            </div>
          </v-flex>
          <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
            <div class="text-sm-right text-xs-right">
              <v-btn
                dark
                depressed
                color="primary"
                @click="showAdvancedSearch = !showAdvancedSearch"
              >
                <v-icon>search</v-icon>
                &nbsp;
                {{ $t('advanced search') }}&nbsp;
                <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
                <em v-else class="fas fa-angle-up" />
              </v-btn>
              <v-btn
                outline
                color="primary"
                :disabled="items.length === 0"
                @click="handleExportXlsx"
              >
                <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <div
          v-if="showAdvancedSearch"
          class="my-4 py-2"
          style="border: 1px solid #eee; border-radius: 10px; position: relative"
        >
          <v-layout wrap class="form-control">
            <v-flex xs6 px-2>
              <div class="caption">{{ $t('beacon') }}</div>
              <multiselect
                v-model="filter.beacon"
                class="mb-2"
                :options="beaconBranchOptions"
                :show-no-results="true"
                :placeholder="$t('Beacon')"
                label="name"
                track-by="beacon_id"
                :searchable="true"
              >
              </multiselect>
            </v-flex>
            <v-flex xs6 px-2>
              <div class="caption">{{ $t('beacon_conversation') }}</div>
              <input v-model="filter.beacon_conversation" type="text" :placeholder="$t('Name')" />
            </v-flex>
            <v-flex xs6 px-2>
              <div class="caption">วันที่เริ่มต้น</div>
              <DatepickerCustomDialog v-model="filter.date_from" :allowed-dates="allowedDates">
                <div class="d-flex">
                  <input
                    type="text"
                    :value="handleGetDateFormatted(filter.date_from)"
                    placeholder="เลือกวันที่เริ่มต้น"
                    readonly
                  />
                  <v-btn flat icon color="error" @click.stop="filter.date_from = ''">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
              </DatepickerCustomDialog>
            </v-flex>

            <v-flex xs6 px-2>
              <div class="caption">วันที่สิ้นสุด</div>
              <DatepickerCustomDialog v-model="filter.date_to" :allowed-dates="allowedDates">
                <div class="d-flex">
                  <input
                    type="text"
                    :value="handleGetDateFormatted(filter.date_to)"
                    placeholder="เลือกวันที่สิ้นสุด"
                    readonly
                  />
                  <v-btn flat icon color="error" @click.stop="filter.date_to = ''">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
              </DatepickerCustomDialog>
            </v-flex>

            <v-flex xs12 class="text-xs-right">
              <v-btn outline color="grey" @click="handleClearSearch">{{
                $t('Clear Search')
              }}</v-btn>
              <v-btn depressed color="primary" @click="handleSearch">
                <em class="fas fa-search mr-1" />
                {{ $t('Search') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>

        <div class="mt-3">
          <v-data-table
            hide-actions
            :pagination.sync="pagination"
            :headers="headers"
            :items="items"
          >
            <template #items="props">
              <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
              <td>{{ props.item.beacon_id }}</td>
              <td>{{ props.item.beacon_name || '-' }}</td>
              <td>{{ props.item.beacon_conversation || '-' }}</td>
            </template>

            <template slot="no-data">
              <div class="text-xs-center">{{ $t('No data') }}</div>
            </template>
          </v-data-table>
          <div class="mt-3 text-xs-right">
            <v-pagination
              v-model="pageNumber"
              :total-visible="6"
              :length="pageLength"
              @input="handleNextPage"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import beaconApi from '@/api/beacon'
import { handleResponse, handleApiError } from '@/api/util'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import { DATETIME } from '@/constants/datetime.js'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    DatepickerCustomDialog,
    Multiselect
  },
  props: ['value', 'initialFilters'],
  data() {
    return {
      selectedCustomer: null,
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      items: [],
      isExport: false,
      headers: [
        { text: `${this.$t('Date')} & ${this.$t('Time')}`, value: 'timestamp' },
        { text: 'Beacon ID', value: 'beacon_id' },
        { text: this.$t('name'), value: 'beacon_name' },
        { text: this.$t('beacon_conversation'), value: 'beacon_conversation' }
      ],
      showAdvancedSearch: false,
      filter: {
        beacon: '',
        beacon_conversation: '',
        date_from: '',
        date_to: ''
      },
      selectedDate: {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    beaconBranchOptions() {
      let options = []
      const tempData = this.$store.state.beaconMasterData.beaconBranch

      if (tempData) {
        options = tempData.map((el) => {
          return { beacon_id: el.beacon_id, name: `${el.beacon_id} - ${el.name}` }
        })
      }
      return options
    }
  },
  mounted() {
    this.initFilters()

    if (this.value) {
      this.selectedCustomer = this.value
      this.handleFetchData()
    }
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await vm.getAnalyticsCustomerTransaction()
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.status === 200) {
          const tempData = response.data.data
          vm.items = tempData
          vm.total = response.data.total
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    },
    async getAnalyticsCustomerTransaction() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        const dateFrom = vm.filter.date_from
          ? dayjs(vm.filter.date_from).format('YYYY-MM-DD')
          : dayjs(vm.selectedDate.start).format('YYYY-MM-DD')

        const dateTo = vm.filter.date_to
          ? dayjs(vm.filter.date_to).format('YYYY-MM-DD')
          : dayjs(vm.selectedDate.end).format('YYYY-MM-DD')
        const config = {
          pageid: vm.selectedBot.pageid,
          data: {
            dateFrom: dateFrom,
            dateTo: dateTo,
            limit: limit,
            offset: vm.offset,
            user_id: vm.selectedCustomer.user_id,
            excluded_conversation: '{default}'
          }
        }

        if (vm.filter.beacon) {
          Object.assign(config.data, { beaconId: vm.filter.beacon.beacon_id })
        }

        if (vm.filter.beacon_conversation) {
          Object.assign(config.data, { beacon_conversation: vm.filter.beacon_conversation })
        }

        vm.$store.dispatch('loading')
        const response = await beaconApi.getAnalyticsCustomerTransaction({ config: config })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)

        if (response && response.status === 200) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        vm.$store.commit('CLEAR_LOADING')
        return null
      }
    },
    handleNextPage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleFetchData()
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        vm.isExport = true
        const response = await vm.getAnalyticsCustomerTransaction()
        const data = response.data.data
        vm.isExport = false

        if (data == null) return
        const requests = data.map((el) => {
          return {
            timestamp: dayjs(el.timestamp).format('DD/MM/YYYY HH:mm'),
            beacon_id: el.beacon_id,
            beacon_name: el.beacon_name,
            beacon_conversation: el.beacon_conversation
          }
        })

        const heading = [['Date & Time', 'Beacon ID', 'Beacon Name', 'Beacon Conversation']]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `beacon-customer-detail.xlsx`)
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    handleSearch() {
      this.handleReset()
    },
    handleClearSearch() {
      this.initFilters()
      this.showAdvancedSearch = false
      this.handleReset()
    },
    handleReset() {
      this.pageNumber = 1
      this.offset = 0
      this.handleFetchData()
    },
    handleGetDateFormatted(value) {
      return value ? dayjs(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    },
    allowedDates(val) {
      return dayjs().diff(val, 'days') > 0
    },
    initFilters() {
      if (this.initialFilters) {
        const { beaconId, dateFrom, dateTo } = this.initialFilters

        this.filter = {
          beacon: this.beaconBranchOptions.find((item) => item.beacon_id === beaconId) || '',
          beacon_conversation: '',
          date_from: dateFrom || '',
          date_to: dateTo || ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics/CustomerDetailDialog.vue